module.exports = __webpack_public_path__ + "static/media/cloud-moon-rain.cf76f52c.svg";